export function hideBodyScroll() {
  document.body.classList.add('no-scroll');
}

export function showBodyScroll() {
  document.body.classList.remove('no-scroll');
}

type ScrollPosition = { top: number; left: number };

/** Scroll offsets (both axes) that center `element` within `container`'s viewport. */
export function getCenteredScrollPosition(
  container: HTMLElement,
  element: HTMLElement
): ScrollPosition {
  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  return {
    top:
      container.scrollTop +
      elementRect.top -
      containerRect.top -
      container.clientHeight / 2 +
      element.clientHeight / 2,
    left:
      container.scrollLeft +
      elementRect.left -
      containerRect.left -
      container.clientWidth / 2 +
      element.clientWidth / 2,
  };
}
